import moment from 'moment'
import { Sex } from '@/lib/enums'
import { DEFAULT_DATE_FORMAT } from './date'

function iso7064 (modulus, radix, chars, code, append) {
  code = code.toUpperCase()
  let targetVal = 0
  for (let i = 0; i < code.length; i++) {
    const val = chars.indexOf(code[i])
    if (val < 0) throw new Error(`ISO7064 mod ${modulus} ${radix}:found illegal character ${code[i]}`)
    targetVal = ((targetVal + val) * radix) % modulus
  }
  const checksum = (modulus - targetVal + 1) % modulus
  return append ? (code + chars[checksum]) : (chars[checksum])
}

export function checkDigitDonation (code, append) {
  return iso7064(37, 2, '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ*', code, append)
}

export function checkDigitIdCard (code, append) {
  return iso7064(11, 2, '0123456789X', code, append)
}

export function validateIdCard (val) {
  const regex = /^[1-9][0-9]{5}[0-9]{4}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}([0-9]|x|X)$/
  return regex.test(val) && checkDigitIdCard(val.substr(0, 17)) === val.substr(17)
}

// https://www.jb51.net/article/109327.htm
export function validateIdCardHm (val) {
  // 通行证有效期分为3年和10年两种，持证人年满18周岁的为10年有效，未满18周岁的为3年有效
  // 第1位: H: 香港; M: 澳门
  // 第2~9位: 个人终身编号
  // 第10~11位: 换证序列号, 第1次为00, 第2次为01, ...
  return /^(H|h|M|m)\d{10}$/.test(val)
}

export function validateIdCardTw (val) {
  return /^[0-9]{10}$/.test(val)
}

export function validateIdCardPassport (val) {
  return /^[a-zA-Z0-9]{5,17}$/.test(val)
}

export function validateIdCardOthers (val) {
  return /^[a-zA-Z0-9_\-()]+$/.test(val)
}

export function parseIdCard (idCard) {
  if (validateIdCard(idCard)) {
    return {
      sex: Number(idCard.charCodeAt(16)) % 2 === 0 ? Sex.Female : Sex.Male,
      birthday: moment(idCard.substr(6, 8)).format(DEFAULT_DATE_FORMAT)
    }
  }
}
